import { SafetyCertificateOutlined, StarFilled } from "@ant-design/icons";
import { useAppConfig } from "../../../hooks/useAppConfig";
import type { TrustBadge, TrustBadgeKind } from "../../../providers/AppConfigProvider";

const ICON_BY_KIND: Record<TrustBadgeKind, React.ReactNode> = {
  BOARD_CERTIFIED: <SafetyCertificateOutlined />,
  ACCREDITED: <SafetyCertificateOutlined />,
  GOOGLE_RATING: <StarFilled style={{ color: "#f59e0b" }} />,
};

export const TrustBand = () => {
  const { data } = useAppConfig();
  const badges: TrustBadge[] = data?.trustBand ?? [];
  if (badges.length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        justifyContent: "center",
        marginTop: "8px",
      }}
    >
      {badges.map((b, idx) => (
        <div
          key={`${b.kind}-${idx}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 12px",
            borderRadius: "999px",
            background: "#ecfdf5",
            border: "1px solid #a7f3d0",
            color: "#065f46",
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: 1.2,
          }}
        >
          <span style={{ fontSize: "14px", lineHeight: 0 }}>
            {ICON_BY_KIND[b.kind]}
          </span>
          {b.label}
        </div>
      ))}
    </div>
  );
};

export default TrustBand;
